export const BASE_URL = process.env.REACT_APP_API_URL;

export const MAUTIC_URL_LOGOUT =
  'http://10.16.150.205:8000/marketing-modules/s/logout';
